import { devLog, devError } from '../utils/devLogger';
import React, { useState, useEffect } from 'react';
import { Card, Row, Col, ProgressBar, Badge } from 'react-bootstrap';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../auth/AuthContext';

const LearnerProgress = () => {
    const { currentUser } = useAuth();
    const [metrics, setMetrics] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!currentUser) return;

        const leaderboardRef = doc(db, 'leaderboard', currentUser.uid);
        const unsubscribe = onSnapshot(leaderboardRef, (doc) => {
            if (doc.exists()) {
                setMetrics(doc.data());
            }
            setLoading(false);
        }, (error) => {
            devError("Error listening to progress:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [currentUser]);

    if (loading) return null; // Or a small spinner

    if (!metrics) {
        return (
            <Card className="shadow-sm mb-4">
                <Card.Body className="text-center text-muted">
                    Start your journey by uploading documents and attending classes!
                </Card.Body>
            </Card>
        );
    }

    const { points, metrics: userMetrics } = metrics;

    return (
        <Card className="shadow-sm mb-4 border-0 bg-primary text-white" style={{ background: 'linear-gradient(45deg, #0d6efd, #0a58ca)' }}>
            <Card.Body>
                <Row className="align-items-center">
                    <Col md={4} className="text-center text-md-start mb-3 mb-md-0">
                        <h6 className="text-white-50 mb-1">Total Points</h6>
                        <h2 className="display-4 fw-bold mb-0">{points}</h2>
                        <Badge bg="light" text="dark" className="mt-2">
                            Rank #{metrics.rank || '-'}
                        </Badge>
                    </Col>

                    <Col md={8}>
                        <div className="mb-3">
                            <div className="d-flex justify-content-between mb-1">
                                <span>Attendance Rate</span>
                                <span>{Math.round(userMetrics?.attendanceRate || 0)}%</span>
                            </div>
                            <ProgressBar
                                now={userMetrics?.attendanceRate || 0}
                                variant="info"
                                style={{ height: '8px', backgroundColor: 'rgba(255,255,255,0.2)' }}
                            />
                        </div>

                        <div>
                            <div className="d-flex justify-content-between mb-1">
                                <span>Document Completion</span>
                                <span>{Math.round(userMetrics?.documentCompletionRate || 0)}%</span>
                            </div>
                            <ProgressBar
                                now={userMetrics?.documentCompletionRate || 0}
                                variant="warning"
                                style={{ height: '8px', backgroundColor: 'rgba(255,255,255,0.2)' }}
                            />
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default LearnerProgress;
